// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container_2_Tz2","bodyContainer":"main_bodyContainer_3GztF"};